/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useState, useEffect } from 'react'

import { PANE_LAYER } from './constants'
import createHTMLMapMarker from './overlay-view'

interface IMapCustomMarker {
  position: google.maps.LatLngLiteral
  map?: google.maps.Map | null | google.maps.StreetViewPanorama
  paneLayer?: PANE_LAYER
  onClick?: () => void
}
export const MapCustomMarker: React.FC<IMapCustomMarker> = ({
  position,
  map,
  children,
  paneLayer = PANE_LAYER.floatPane,
  onClick,
}) => {
  const [marker, setMarker] = useState<google.maps.OverlayView>()

  useEffect(() => {
    if (!marker) {
      setMarker(createHTMLMapMarker({ position, content: children, paneLayer, onClick }))
    }

    return () => {
      if (marker) {
        marker.setMap(null)
      }
    }
  }, [marker]) // eslint-disable-line

  useEffect(() => {
    if (marker && map) {
      marker.setMap(map)
    }
  }, [marker, map])

  return null
}
